"use strict";
export { DialogActionTrigger, DialogBackdrop, DialogBody, DialogCloseTrigger, DialogContent, DialogContext, DialogDescription, DialogFooter, DialogHeader, DialogPositioner, DialogPropsProvider, DialogRoot, DialogRootProvider, DialogTitle, DialogTrigger, useDialogStyles } from './dialog.js';
export { useDialog, useDialogContext } from '@ark-ui/react/dialog';
import * as namespace from './namespace.js';
export { namespace as Dialog };
